export const SuggestionsQuestions21 =[
    {
        id:"R21-01",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章一以哪個詞概括孔子所處時代的禮樂秩序變化？',
        options:[
            {
                option:'A. 禮崩樂壞',
            },
            {
                option:'B. 天下大同',
            },
            {
                option:'C. 文質彬彬',
            },
            {
                option:'D. 和而不同',
            }
        ],
        correctAnswer:'A. 禮崩樂壞',
        explanation: '開首說周王室衰微、諸侯爭霸，禮樂秩序逐漸瓦解。',
        score: 1,
        source: '篇章一 開首',
        articleIndex: [0],
        // ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R21-02",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章一，「己所不欲，勿施於人」主要要求人怎樣待人？',
        options:[
            {
                option:'A. 要求別人接受自己的喜好',
            },
            {
                option:'B. 以自己的感受理解別人，約束行為',
            },
            {
                option:'C. 對任何請求都答應',
            },
            {
                option:'D. 把自己的利益放在首位',
            }
        ],
        correctAnswer:'B. 以自己的感受理解別人，約束行為',
        explanation: '「恕」要求由自身感受想到他人處境。',
        score: 1,
        source: '篇章一 忠恕',
        articleIndex: [0],
        // ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R21-03",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章二列出的「四君子」是哪一組植物？',
        options:[
            {
                option:'A. 松、柏、蓮、柳',
            },
            {
                option:'B. 梅、蓮、竹、松',
            },
            {
                option:'C. 梅、蘭、竹、菊',
            },
            {
                option:'D. 蘭、桃、菊、柏',
            }
        ],
        correctAnswer:'C. 梅、蘭、竹、菊',
        explanation: '文中直接列出梅、蘭、竹、菊。',
        score: 1,
        source: '篇章二 比德及四君子',
        articleIndex: [1],
        // ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R21-04",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章二說君子不再只看出身，而看學習、選擇及行為，這意味著甚麼？',
        options:[
            {
                option:'A. 只有貴族子弟才可成為君子',
            },
            {
                option:'B. 只要有名望便能成為君子',
            },
            {
                option:'C. 品德完全由出生決定',
            },
            {
                option:'D. 人可透過修身追求人格理想',
            }
        ],
        correctAnswer:'D. 人可透過修身追求人格理想',
        explanation: '君子由身份稱謂轉向可以透過修養追求的人格。',
        score: 1,
        source: '篇章二 第2段',
        articleIndex: [1],
        // ability_point: '2.2 生成推斷'
    },
    {
        id:"R21-05",
        category:"一般閱讀題",
        type:'選擇題',
        question: '把篇章一的「禮」與篇章二的「文質彬彬」合讀，哪項理解最恰當？',
        options:[
            {
                option:'A. 內在德性應與合宜的外在言行配合',
            },
            {
                option:'B. 禮儀愈華麗便必定愈有德',
            },
            {
                option:'C. 只要心地好，行為便不必考慮他人',
            },
            {
                option:'D. 君子應完全拒絕外在修養',
            }
        ],
        correctAnswer:'A. 內在德性應與合宜的外在言行配合',
        explanation: '兩篇均強調內在與外在的配合。',
        score: 1,
        source: '篇章一 禮；篇章二 文質彬彬',
        articleIndex: [0,1],
        // ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R21-06",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章一，分別說明「忠」與「信」的意思。',
        options:[],
        correctAnswer:'忠是待人做事盡心；信是與人交往誠實可靠。',
        explanation: '「忠」解釋準確（1分）；「信」解釋準確（1分）。',
        score: 2,
        source: '篇章一 忠恕、信',
        articleIndex: [0],
        // ability_point: '2.1 建構文本字面意義'

    },
    {
        id:"R21-07",
        category:"一般閱讀題",
        type:'短答題',
        question: '孔子在馬廄失火後先問「傷人乎」，這個細節反映他重視甚麼？請連繫「仁」說明。',
        options:[],
        correctAnswer:'他先關心人的安危，把對人的關愛放在重要位置，以日常行動體現仁者愛人。',
        explanation: '指出關心人的安危（1分）；連繫仁者愛人（1分）。不宜推論他完全不關心動物。',
        score: 2,
        source: '篇章一 仁',
        articleIndex: [0],
        // ability_point: '2.2 生成推斷'
    },
    {
        id:"R21-08",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章一，「孝悌」與「忠恕」如何幫助人擴展關懷？',
        options:[],
        correctAnswer:'孝悌使人在家庭學習敬愛、責任；忠恕讓人盡心待人、設身處地，把關懷推向更廣的人際關係。',
        explanation: '家庭中學習關愛（1分）；忠恕的作用（1分）；說明由近及遠的關係（1分）。',
        score: 3,
        source: '篇章一 孝悌、忠恕、五常',
        articleIndex: [0],
        // ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R21-09",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章二引用〈竹石〉，怎樣把竹的形態轉化為人格意義？',
        options:[],
        correctAnswer:'竹扎根破巖、經風霜仍堅勁，象徵人在磨難中堅守原則、意志不屈。',
        explanation: '指出竹的具體特徵（1分）；相應人格（1分）；說明以物比德的表達（1分）。',
        score: 3,
        source: '篇章二 竹石',
        articleIndex: [1],
        // ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R21-10",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章一的「義」和篇章二「君子和而不同」如何共同說明君子面對群體意見時的態度？',
        options:[],
        correctAnswer:'義要求以正當原則衡量取捨；和而不同要求和睦相處而保持判斷。因此君子可尊重別人，卻不為合群而盲從不當行為。',
        explanation: '說明義（1分）；說明和而不同（1分）；整合成具體態度（1分）。',
        score: 3,
        source: '篇章一 義；篇章二 和而不同',
        articleIndex: [0,1],
        // ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R21-11",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章一，樊遲問仁時，孔子最簡潔的回答是甚麼？',
        options:[{
            option:'A. 知人'
        },{
            option:'B. 愛人'
        },{
            option:'C. 克己'
        },{
            option:'D. 守信'
        }],
        correctAnswer:'B. 愛人',
        explanation: '樊遲問仁，孔子答「愛人」。',
        score: 1,
        source: '篇章一 仁 末段及語譯',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R21-12",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章二，誰稱蓮為「花之君子」？',
        options:[{
            option:'A. 劉禹錫'
        },{
            option:'B. 鄭燮'
        },{
            option:'C. 周敦頤'
        },{
            option:'D. 曾子'
        }],
        correctAnswer:'C. 周敦頤',
        explanation: '〈愛蓮說〉為周敦頤作品。',
        score: 1,
        source: '篇章二 愛蓮說',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R21-13",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章一「四端」分頁，列出「義」及「智」各以哪一種心為開端。',
        options:[],
        correctAnswer:'義：羞惡之心；智：是非之心。',
        explanation: '每個正確配對1分。',
        score: 2,
        source: '篇章一 四端',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R21-14",
        category:"能力點題",
        type:'短答題',
        question: '從篇章二摘錄最直接表明「君子遇事先反省自己」的完整一句《論語》引文。',
        options:[],
        correctAnswer:'「君子求諸己，小人求諸人。」',
        explanation: '準確摘錄完整對句（1分）。',
        score: 1,
        source: '篇章二 求諸己',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R21-15",
        category:"能力點題",
        type:'選擇題',
        question: '若要查找「道德判斷如何衡量追求富貴的方法」，應優先進入篇章一哪個分頁？',
        options:[{
            option:'A. 信'
        },{
            option:'B. 孝悌'
        },{
            option:'C. 仁'
        },{
            option:'D. 義'
        }],
        correctAnswer:'D. 義',
        explanation: '義分頁直接談富貴的取得方式是否合道。',
        score: 1,
        source: '篇章一 分頁標題與內容',
        articleIndex: [0],
        ability_point: '1.2 跨來源搜索、導航與篩選'
       
    },
    {
        id:"R21-16",
        category:"能力點題",
        type:'選擇題',
        question: '要研究「由親人推及陌生人的關懷」並找出相關名句，哪條閱讀路徑最合適？',
        options:[{
            option:'A. 篇章一「孝悌」→「忠恕」'
        },{
            option:'B. 篇章二「四君子」→〈竹石〉'
        },{
            option:'C. 篇章一開首→篇章二詞語起源'
        },{
            option:'D. 篇章二〈陋室銘〉→篇章一「信」'
        }],
        correctAnswer:'A. 篇章一「孝悌」→「忠恕」',
        explanation: '孝悌提供由近及遠的關懷，忠恕提供推己及人的原則。',
        score: 1,
        source: '篇章一 孝悌、忠恕',
        articleIndex: [0],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R21-17",
        category:"能力點題",
        type:'短答題',
        question: '你要製作「君子的名稱與形象如何改變」簡介。請指出篇章二中應優先選讀的兩處內容，並說明各自用途。',
        options:[],
        correctAnswer:'選開首關於身份到品德的轉變，交代詞義發展；選比德、蓮或竹的段落，交代文人如何以自然形象表現人格。',
        explanation: '兩處位置各1分；對應用途各1分。',
        score: 4,
        source: '篇章二 開首及比德部分',
        articleIndex: [1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R21-18",
        category:"能力點題",
        type:'短答題',
        question: '若要比較「做人要有內在根基」與「言行要有外在分寸」，請從兩篇文章各選一處資料，說明選擇原因。',
        options:[],
        correctAnswer:'篇章一「禮」談仁是內在動力、禮是外在規範；篇章二「文質彬彬」談內在品德與外在修養配合。兩處可互相對照。',
        explanation: '每篇合適資料各1分；說明兩處與研究目的的關係（1分）。',
        score: 3,
        source: '篇章一 禮；篇章二 文質彬彬',
        articleIndex: [0,1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R21-19",
        category:"能力點題",
        type:'選擇題',
        question: '篇章一「克己復禮」在文中的意思最接近哪一項？',
        options:[{
            option:'A. 壓抑別人，使他們服從自己'
        },{
            option:'B. 只要恢復古代服飾即可'
        },{
            option:'C. 約束自己的欲望，使言行合乎準則'
        },{
            option:'D. 拒絕一切情感和人際關係'
        }],
        correctAnswer:'C. 約束自己的欲望，使言行合乎準則',
        explanation: '文中分別解釋克己和復禮。',
        score: 1,
        source: '篇章一 禮',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R21-20",
        category:"能力點題",
        type:'選擇題',
        question: '篇章二「君子和而不同」的意思是甚麼？',
        options:[{
            option:'A. 表面附和，私下反對'
        },{
            option:'B. 凡事提出相反意見'
        },{
            option:'C. 只與觀點完全相同的人來往'
        },{
            option:'D. 能和睦相處，同時保有自己的判斷'
        }],
        correctAnswer:'D. 能和睦相處，同時保有自己的判斷',
        explanation: '和諧並不等於盲目附和。',
        score: 1,
        source: '篇章二 和而不同',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R21-21",
        category:"能力點題",
        type:'短答題',
        question: '用自己的話解釋篇章一「仁，人心也；義，人路也」的比喻。',
        options:[],
        correctAnswer:'仁是內在關愛人的道德之心；義是行事應遵循的正當方向或準則。',
        explanation: '仁的內在意義（1分）；義的方向意義（1分）。',
        score: 2,
        source: '篇章一 義',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R21-22",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章二，解釋「文質彬彬」所要求的兩方面。',
        options:[],
        correctAnswer:'內在品德與外在修養配合得宜，既不粗野，也不只有表面形式。',
        explanation: '內在品德（1分）；外在修養與內在相稱（1分）。',
        score: 2,
        source: '篇章二 文質彬彬',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R21-23",
        category:"能力點題",
        type:'選擇題',
        question: '篇章一說喪禮「與其易也，寧戚」。由此可推斷孔子更重視甚麼？',
        options:[
            {
                option:'A. 儀式背後真實的哀傷和敬意'
            },
            {
                option:'B. 賓客人數與排場'
            },
            {
                option:'C. 形式熟練便可取代情感'
            },
            {
                option:'D. 所有儀節都應取消'
            }
        ],
        correctAnswer:'A. 儀式背後真實的哀傷和敬意',
        explanation: '文中以真情支撐禮的價值。',
        score: 1,
        source: '篇章一 禮之本',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id:"R21-24",
        category:"能力點題",
        type:'選擇題',
        question: '篇章二以蓮「出淤泥而不染」比德，可以推斷人格與環境的關係是甚麼？',
        options:[
            {
                option:'A. 環境不佳便必定失去品德'
            },
            {
                option:'B. 人在複雜環境中仍可作出守正的選擇'
            },
            {
                option:'C. 只要遠離所有人才能保持清白'
            },
            {
                option:'D. 出身可以完全代替修養'
            }
        ],
        correctAnswer:'B. 人在複雜環境中仍可作出守正的選擇',
        explanation: '蓮的意象表達在困難環境中保持正直的可能。',
        score: 1,
        source: '篇章二 愛蓮說',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id:"R21-25",
        category:"能力點題",
        type:'短答題',
        question: '篇章一說孟子以「孺子入井」說明不忍人之心，並排除結交父母及求取名聲的動機。這暗示他怎樣理解惻隱之心？',
        options:[],
        correctAnswer:'惻隱之心可自發產生於看見他人危險之時，不必以獲利或被稱讚為前提。',
        explanation: '自發關懷（1分）；非為名利（1分）；結合排除動機的文字作證（1分）。',
        score: 3,
        source: '篇章一 四端',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id:"R21-26",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章二對〈陋室銘〉的解釋，可推斷劉禹錫衡量生活價值時更看重甚麼？請舉一項文字依據。',
        options:[],
        correctAnswer:'更看重內在品格，而非居室是否華麗。「斯是陋室，惟吾德馨」以德馨解釋陋室仍有意義。',
        explanation: '合理推斷（1分）；準確引文或概述（1分）；連繫證據（1分）。',
        score: 3,
        source: '篇章二 陋室銘',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id:"R21-27",
        category:"能力點題",
        type:'選擇題',
        question: '綜合篇章一，哪一項最完整地說明儒家核心概念的關係？',
        options:[
            {
                option:'A. 五常互相排斥，任選一項即可'
            },
            {
                option:'B. 禮完全取代仁，形式最重要'
            },
            {
                option:'C. 仁為重要核心，各概念從不同方面實踐關愛與判斷'
            },
            {
                option:'D. 孝悌只准人關心自己的家庭'
            }
        ],
        correctAnswer:'C. 仁為重要核心，各概念從不同方面實踐關愛與判斷',
        explanation: '結尾把各概念整理為互相聯繫的價值體系。',
        score: 1,
        source: '篇章一 全文及五常',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R21-28",
        category:"能力點題",
        type:'選擇題',
        question: '綜合篇章二，文章主要沿哪條思路展開？',
        options:[
            {
                option:'A. 身份稱謂→人格修養→文學與自然形象的表現'
            },
            {
                option:'B. 植物分類→栽種方法→園林設計'
            },
            {
                option:'C. 科舉成績→官職高低→財富多寡'
            },
            {
                option:'D. 君子服飾→宴會儀式→住宅建築'
            }
        ],
        correctAnswer:'A. 身份稱謂→人格修養→文學與自然形象的表現',
        explanation: '文章由詞義發展，轉到君子表現及後世文化形象。',
        score: 1,
        source: '篇章二 全文',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R21-29",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章一，說明「四端」為甚麼只是道德成長的開端，並指出人還需要做甚麼。',
        options:[],
        correctAnswer: '四端是內在道德萌芽，尚須保存、擴充和實踐，才逐漸形成穩定德性；不能只憑一時的情感就認為修養已完成。',
        explanation: '萌芽／開端（1分）；保存擴充實踐（1分）；連繫穩定德性的形成（1分）。',
        score: 3,
        source: '篇章一 四端',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R21-30",
        category:"能力點題",
        type:'短答題',
        question: '綜合篇章二，君子面對自己、他人及外在表現時，各應有甚麼態度？',
        options:[],
        correctAnswer: '對己先反省；對人和睦而不盲從；外在修養應與內在品德相稱。',
        explanation: '每方面準確且對應文意各1分。',
        score: 3,
        source: '篇章二 求諸己、和而不同、文質彬彬',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R21-31",
        category:"能力點題",
        type:'選擇題',
        question: '篇章一「君子喻於義」與篇章二「君子求諸己」共同指向甚麼修養方向？',
        options:[
            {
                option:'A. 透過責怪別人維護名聲'
            },
            {
                option:'B. 以正當原則要求自己並反省行為'
            },
            {
                option:'C. 以他人的讚賞決定是非'
            },
            {
                option:'D. 只在有利益時遵守原則'
            }
        ],
        correctAnswer:'B. 以正當原則要求自己並反省行為',
        explanation: '義是判斷取捨的準則，求諸己使準則落在自我要求上。',
        score: 1,
        source: '篇章一 義；篇章二 求諸己',
        articleIndex: [0,1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R21-32",
        category:"能力點題",
        type:'選擇題',
        question: '把篇章一「信」與篇章二開首的「君子之交」合讀，哪項最合理？',
        options:[
            {
                option:'A. 友誼只需有共同利益'
            },
            {
                option:'B. 不計利益便可不守承諾'
            },
            {
                option:'C. 真誠和誠信無關'
            },
            {
                option:'D. 誠實可靠有助建立真誠而不只計較利益的友誼'
            }
        ],
        correctAnswer:'D. 誠實可靠有助建立真誠而不只計較利益的友誼',
        explanation: '兩篇分別說明可靠交往和君子友誼的取向。',
        score: 1,
        source: '篇章一 信；篇章二 開首',
        articleIndex: [0,1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R21-33",
        category:"能力點題",
        type:'短答題',
        question: '篇章一說禮須有真情支撐，篇章二說君子「有修養，但不做作」。兩者有何共同要求？請各舉一項證據。',
        options:[],
        correctAnswer: '都要求外在形式與內在真誠配合。篇章一以喪禮重哀戚說明；篇章二以文質彬彬說明品德與外在修養應相稱。',
        explanation: '共同要求（1分）；每篇有效證據各1分；說明二者關係（1分）。',
        score: 4,
        source: '篇章一 禮；篇章二 文質彬彬',
        articleIndex: [0,1],
        ability_point: '2.4 整合跨文本信息'

    },
    {
        id:"R21-34",
        category:"能力點題",
        type:'短答題',
        question: '結合兩篇文章，說明一個人如何由「仁」的關懷走向「君子」的人格實踐。至少引用兩個不同篇章的內容。',
        options:[],
        correctAnswer: '篇章一從愛人出發，以忠恕理解他人、以禮義規範行動；篇章二要求自省、保持獨立判斷，使這些價值成為具體修養和選擇。',
        explanation: '篇章一內容（1分）；篇章二內容（1分）；連繫內在關懷與實際修養（1分）。',
        score: 3,
        source: '篇章一；篇章二',
        articleIndex: [0,1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R21-35",
        category:"能力點題",
        type:'選擇題',
        question: "判斷以下知識卡能否上線：「儒家的核心是『仁』。仁使人心中有他人；義、禮、智、信則從不同方面規範人的判斷、行為與人際關係，共同形成儒家的價值體系。」",
        options: [{
            option:'A. 可以直接上線：內容準確，表述清楚'
        },
        {
            option:'B. 基本正確，需要小幅修改'
        },
        {
            option:'C. 容易造成明顯誤解，需要重新改寫'
        }
        ],
        correctAnswer:'A. 可以直接上線：內容準確，表述清楚',
        explanation: '原教師答案為A；卡片準確呈現仁的重要位置及概念間的聯繫。保留原三個判斷選項，獨立計為選擇題。',
        score: 1,
        source: '文化傳統工作紙1 知識卡一；篇章一',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },
    {
        id:"R21-36",
        category:"能力點題",
        type:'選擇題',
        question: "判斷以下知識卡能否上線：「『君子』原本主要是一種身份稱謂，經過孔子以後逐漸成為理想人格的名稱。後世文人又用蓮、竹、梅等形象表現君子的品格。」",
        options: [{
            option:'A. 可以直接上線：內容準確，表述清楚'
        },
        {
            option:'B. 基本正確，需要小幅修改'
        },
        {
            option:'C. 容易造成明顯誤解，需要重新改寫'
        }
        ],
        correctAnswer:'B. 基本正確，需要小幅修改',
        explanation: '原教師答案為B。「經過孔子以後」應改為突出孔子本人把身份稱謂轉向品德修養。改寫要求見原題對照，這裏只計判斷選擇。',
        score: 1,
        source: '文化傳統工作紙1 知識卡二；篇章二',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },
    {
        id:"R21-37",
        category:"能力點題",
        type:'短答題',
        question: "知識卡三說：「孟子主張性善，荀子主張性惡，因此兩人的儒家思想方向完全相反：孟子相信人依靠天性便能成為有德之人，荀子則認為只能依靠外在規則約束人。」請指出兩項主要問題，並改寫成準確的簡短介紹。 (補充資料：原工作紙教師說明指出，荀子重視後天學習、教化和禮義，兩人皆關心人如何經修養成德。)",
        correctAnswer: '問題一：把人性論分歧誇大為思想方向完全相反。問題二：把孟子簡化為只靠天性，把荀子簡化為只靠約束。可改寫：孟子重視保存擴充善端，荀子重視後天學習、教化與禮義；兩者人性觀不同，都關心修養成德。',
        explanation: '指出完全相反的過度概括（1分）；指出對成德方法的簡化（1分）；準確改寫孟子（1分）；準確改寫荀子及共同關懷（1分）。',
        score: 4,
        source: '文化傳統工作紙1 知識卡三及教師答案；篇章一 四端',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },
    {
        id:"R21-38",
        category:"能力點題",
        type:'短答題',
        question: "有人說：「文章引用了孔子的話，所以其中對兩千多年文化發展的每一項概括都已被證明。」請評估此說法，並指出一項可補充的查證方法。",
        correctAnswer: '不足。孔子引文能支持相關思想，不能單獨證明後世每個時期的發展。可查不同時代有出處的文獻或研究，核對君子或五常概念的使用。',
        explanation: '辨明引文能支持的範圍（1分）；指出推論過度（1分）；具體查證方法（1分）。',
        score: 3,
        source: '篇章一 五常；篇章二 文化發展',
        articleIndex: [0, 1],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id:"R21-39",
        category:"能力點題",
        type:'選擇題',
        question: "篇章一以缺少輗、軏的車輛說明「信」，主要有甚麼作用？",
        options: [{
            option:'A. 交代古代造車的全部工序'
        },
        {
            option:'B. 證明信用比所有德性都重要'
        },
        {
            option:'C. 以熟悉事物具體說明信用在人際關係中的作用'
        },
        {
            option:'D. 說明沒有車的人不需要誠信'
        }
        ],
        correctAnswer: 'C. 以熟悉事物具體說明信用在人際關係中的作用',
        explanation: '用車不能前行類比人無信難以立足，讓抽象概念具體化。',
        score: 1,
        source: '篇章一 信',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R21-40",
        category:"能力點題",
        type:'選擇題',
        question: "篇章二先介紹君子詞義，再舉蓮、竹等形象，主要有甚麼作用？",
        options: [{
            option:'A. 以具體文學形象呈現人格理想的文化延伸'
        },
        {
            option:'B. 證明植物真的具有人的思想'
        },
        {
            option:'C. 以寫景完全取代思想說明'
        },
        {
            option:'D. 把君子的標準限於植物外觀'
        }
        ],
        correctAnswer: 'A. 以具體文學形象呈現人格理想的文化延伸',
        explanation: '例子展示人格理想如何進入作品及比德傳統。',
        score: 1,
        source: '篇章二 結構及比德',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R21-41",
        category:"能力點題",
        type:'短答題',
        question: "篇章一把核心概念安排成可互相跳轉的分頁，對閱讀有甚麼便利？又可能造成甚麼理解上的不足？",
        options: [],
        correctAnswer: '方便按問題迅速找到特定概念並作比較；若只讀單一分頁，可能忽略概念彼此相連，需配合總結「五常」理解。',
        explanation: '便利（1分）；可能不足（1分）；具體改善閱讀方法（1分）。',
        score: 3,
        source: '篇章一 分頁與五常總結',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R21-42",
        category:"能力點題",
        type:'短答題',
        question: "篇章二以「君子求諸己，小人求諸人」說明修養。這種對照方式如何幫助讀者理解重點？",
        options: [],
        correctAnswer: '把反省自己與責怪他人並列，使兩種態度差異鮮明，突出君子應先要求自己的主張。',
        explanation: '辨識對照內容（1分）；指出突顯主張的效果（1分）。',
        score: 2,
        source: '篇章二 求諸己',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R21-43",
        category:"能力點題",
        type:'選擇題',
        question: "甲說「仁重內心，所以禮不重要」；乙說「守好儀式就一定有仁」。根據篇章一，怎樣處理兩種說法？",
        options: [
            {
                option:'A. 甲對乙錯'
            },
            {
                option:'B. 兩者都割裂了內在德性與外在實踐的關係'
            },
            {
                option:'C. 乙對甲錯'
            },
            {
                option:'D. 兩者適用於所有情況'
            }
        ],
        correctAnswer: 'B. 兩者都割裂了內在德性與外在實踐的關係',
        explanation: '仁提供道德動力，禮讓心意落實，不能互相取代。',
        score: 1,
        source: '篇章一 禮',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id:"R21-44",
        category:"能力點題",
        type:'選擇題',
        question: "篇章二說君子由身份轉向修養，又引〈陋室銘〉「往來無白丁」。哪項處理最審慎？",
        options: [
            {
                option:'A. 因此斷定君子永遠只看出身'
            },
            {
                option:'B. 把引文刪除便不必討論'
            },
            {
                option:'C. 認為「白丁」與文學語境完全無關'
            },
            {
                option:'D. 區分孔子的人格觀與後世作品的交遊描寫，保留其張力作分析'
            }
        ],
        correctAnswer: 'D. 區分孔子的人格觀與後世作品的交遊描寫，保留其張力作分析',
        explanation: '不同時代作品有自身語境，不能用單句推翻或概括全部君子思想。',
        score: 1,
        source: '篇章二 君子詞義、陋室銘',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id:"R21-45",
        category:"能力點題",
        type:'短答題',
        question: "「和而不同」同時要求和諧與保留不同意見，兩者是否矛盾？請根據篇章二說明。",
        correctAnswer: "不必矛盾。和諧是相互尊重的相處方式，不等於意見一致；君子可保留判斷，並以合宜言行表達分歧。",
        explanation: "區分相處方式與意見內容（1分）；說明可並存（1分）；連繫文意（1分）。",
        score: 3,
        source: "篇章二 和而不同",
        articleIndex: [1],
        ability_point: "3.3 發現並處理衝突"
    },
    {
        id:"R21-46",
        category:"能力點題",
        type:'短答題',
        question: "有人認為「孝悌從親人開始」與「仁者愛人」矛盾，因為前者只愛自己家人。請用篇章一的資料修正這個理解。",
        correctAnswer: "從親人開始不等於停留在親人。有若說孝悌是為仁之本，孟子說「老吾老，以及人之老」，顯示家庭關愛是推向他人的起點。",
        explanation: "指出起點不等於界限（1分）；相關文字證據（1分）；解釋由近及遠（1分）。",
        score: 3,
        source: "篇章一 仁、孝悌",
        articleIndex: [0],
        ability_point: "3.3 發現並處理衝突"
    },
    {
        id:"R21-47",
        category:"能力點題",
        type:'選擇題',
        question: "朋友要求你轉傳令同學尷尬的照片。哪項行動最切合「恕」？",
        options: [
            {
                option:'A. 因為是朋友便立刻轉傳'
            },
            {
                option:'B. 只要沒有拍到自己便可轉傳'
            },
            {
                option:'C. 想到自己也不願被公開取笑，先尊重當事人的意願'
            },
            {
                option:'D. 轉傳後再要求別人不要取笑自己'
            }
        ],
        correctAnswer: 'C. 想到自己也不願被公開取笑，先尊重當事人的意願',
        explanation: '由自身感受理解他人，並約束可能傷害人的行為。',
        score: 1,
        source: '篇章一 忠恕；新增網絡情境',
        articleIndex: [0],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id:"R21-48",
        category:"能力點題",
        type:'選擇題',
        question: "小組報告失誤，組長先檢視自己是否交代清楚，再和組員改善。這最直接體現哪一句？",
        options: [
            {
                option:'A. 君子求諸己'
            },
            {
                option:'B. 文勝質則史'
            },
            {
                option:'C. 大車無輗'
            },
            {
                option:'D. 君子喻於義'
            }
        ],
        correctAnswer: 'A. 君子求諸己',
        explanation: '情境重點是先反省自己的責任。',
        score: 1,
        source: '篇章二 求諸己；新增合作情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id:"R21-49",
        category:"能力點題",
        type:'短答題',
        question: "回想一次需要作出選擇的日常經歷，交代背景、取捨及原來的選擇；選一個相關儒家概念，說明其意思及如何影響判斷，最後寫出若再遇同樣情況會怎樣做。毋須透露個人私隱。",
        correctAnswer: '示例：朋友請我隱瞞組內缺交功課，我原來答應。重新用「信」思考，誠實可靠不等於替人說謊；我會勸朋友自行交代並協助補做，必要時如實向老師說明。',
        explanation: '交代背景及取捨（1分）；原來選擇（1分）；概念理解準確（1分）；連繫情境分析（1分）；提出有理由的新選擇（1分）。',
        score: 5,
        source: '文化傳統工作紙2 三步反思活動',
        articleIndex: [],
        ability_point: '4.1 將理解遷移至新情境',
        isSuggested: true
    },
    {
        id: "R21-50",
        category:"能力點題",
        type:'短答題',
        question: "學校活動原定要求昂貴服飾，令部分同學感到壓力。請運用「禮」與「仁」提出一項改善方案，並解釋理由。",
        correctAnswer: '改用整潔而可負擔的服飾，保留尊重場合的基本要求。仁使人顧及同學負擔；禮重真誠敬意，不應只求奢華排場。',
        explanation: '具體方案（1分）；仁的連繫（1分）；禮的連繫（1分）。',
        score: 3,
        source: '篇章一 仁、禮；新增校園情境',
        articleIndex: [0],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: "R21-51",
        category:"能力點題",
        type:'選擇題',
        question: "要把「君子和而不同」改寫成班級海報標語，哪一項既準確又適合受眾？",
        options: [
            {
                option:'A. 大家想法必須一樣'
            },
            {
                option:'B. 尊重彼此，也保留自己的判斷'
            },
            {
                option:'C. 只要不同意，就停止合作'
            },
            {
                option:'D. 少數意見永遠較高明'
            }
        ],
        correctAnswer: 'B. 尊重彼此，也保留自己的判斷',
        explanation: '把和睦相處與獨立判斷轉化成清晰的校園訊息。',
        score: 1,
        source: '篇章二；新增海報任務',
        articleIndex: [1],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: "R21-52",
        category:"能力點題",
        type:'選擇題',
        question: "要為「信用使關係走得更遠」設計新比喻，哪個方案最切合篇章一？",
        options: [
            {
                option:'A. 把信用畫成只供欣賞的花瓶'
            },
            {
                option:'B. 把承諾畫成可任意更改的廣告'
            },
            {
                option:'C. 把誠信畫成避免所有分歧的膠帶'
            },
            {
                option:'D. 把信用畫成橋的支柱，承托雙方可靠的來往'
            }
        ],
        correctAnswer: 'D. 把信用畫成橋的支柱，承托雙方可靠的來往',
        explanation: '橋柱支撐來往，能傳達信用支持交往的關係。',
        score: 1,
        source: '篇章一 信；新增圖像方案',
        articleIndex: [0],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: "R21-53",
        category:"能力點題",
        type:'短答題',
        question: "為初中同學寫一張40至70字的「仁與禮」知識卡，包含兩者關係及一個日常例子，避免只列定義。",
        correctAnswer: '仁是心中有他人，禮是把關懷變成合宜的行動。例如同學發言時，我們既尊重他的感受，也專心聆聽、不隨意打斷，讓真誠與分寸相配合。',
        explanation: '仁與禮關係準確（1分）；合適例子（1分）；整合而非只堆砌詞語（1分）；適合受眾、字數大致符合（1分）。',
        score: 4,
        source: '篇章一 仁、禮；新增創作任務',
        articleIndex: [0],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: "R21-54",
        category:"能力點題",
        type:'短答題',
        question: "選一種生活中常見的物件，仿照篇章二「比德」的方法，寫40至70字的介紹，把物件的一項特徵連繫到一種君子品格。可自選物件，但不要直接照抄蓮或竹的例子。",
        correctAnswer: '示例：尺子刻度清楚，量長短時不因物件昂貴而改變標準。它讓我想到君子重義：面對利益或人情，仍應以正當原則作判斷，不隨意改變尺度。',
        explanation: '物件特徵清楚（1分）；品格準確（1分）；兩者連繫合理且有新表達（1分）；表達完整、字數大致符合（1分）。',
        score: 4,
        source: '篇章二 比德；新增創作任務',
        articleIndex: [1],
        ability_point: '4.2 創造並傳達新意義'
    }
]